var _rect, _path, _rect2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgViewIconGoodOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3213 6.39225C9.1213 7.59225 6.25 7.91369 5.25 8.16369V17.3534C6.18542 17.3534 7.24056 17.6244 10.7827 18.5355C13.4982 19.2339 15.4448 19.4873 16.9479 19.4873C18.4509 19.4873 18.9358 18.1619 18.381 17.3534C19.7349 17.1485 20.5145 15.3944 19.5985 14.4979C21.1236 14.4979 21.6707 12.6537 20.7094 11.7888C21.9707 11.4537 22.5891 9.50129 20.8848 8.8829C19.6705 8.4423 17.5392 7.8136 14.9992 7.27859C15.2492 6.77859 16.0934 4.76476 16.4474 3.47065C16.8954 1.83288 15.2031 0.619084 14.1219 1.8292C12.8027 3.30557 11.8213 4.89225 10.3213 6.39225Z",
    fill: "#FEA791"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 7,
    width: 5,
    height: 12,
    rx: 1,
    fill: "#407EDA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIconGoodOn);
export default __webpack_public_path__ + "static/media/view_icon_good_on.e20f7577c82d1733602ff0d3c42cd882.svg";
export { ForwardRef as ReactComponent };